import { DEFAULT_PAGINATION_LIMIT } from "../../../../../globalConstants";

export const STRINGS = {
  ADD_MODE: "A",
  EDIT_MODE: "E",
  DEFAULT_PAGINATION_LIMIT: DEFAULT_PAGINATION_LIMIT,
  DEFAULT_PAGE: 1,
  MODAL_MODE: {
    ADD: "A",
    EDIT: "E",
    DELETE: "D",
    SUCCESS: "S",
    FAILURE: "F",
    DEFAULT: "",
  },
  MODAL_SIZE: {
    X_SMALL: "xs",
    SMALL: "sm",
    MEDIUM: "md",
    LARGE: "lg",
  },
};
